import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'nr-add-trip-modal',
	templateUrl: './add-trip-modal.component.html',
	styleUrls: ['./add-trip-modal.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		TranslateModule,
	],
})
export class AddTripModalComponent {

	public tripId: number;

	constructor(
		private modalCtrl: ModalController,
	) {
	}

	cancel() {
		return this.modalCtrl.dismiss(null, 'cancel');
	}

	confirm() {
		return this.modalCtrl.dismiss(this.tripId, 'confirm');
	}
}
